export class Base {
  id?: string;
  created_at?: Date | string | null;
}
